

































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { EFileFormat } from '@/models'
import GroupChatService from '@/services/GroupChatService'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import FormatDate from '@/helpers/FormatDate'
import CheckDevice from '@/helpers/CheckDevice'
import {EhumbNailsDisplay, EListSort} from '@/models/Setting/Enum'
import PreviewText from '@/helpers/PreviewText'
import MessageService from '@/services/MessageService'
import ModalFullImageViewer from '@/components/Modal/ModalFullImageViewer.vue'
import {getModule} from "vuex-module-decorators";
import Setting from "@/store/modules/Setting";
import store from "@/store";
import {IDropDown} from "@/views/Group/TopPage/NewFeed/Layout/NewFeedLayout.vue";
const SettingModule = getModule(Setting, store)

@Component({
  components: {
    ModalFullImageViewer
  }
})
export default class GalleryModal extends Vue {
  @Prop() private idGroupChat: any
  galleries: any[] = []
  isLoading: boolean = true
  private file_name_download: string = ''
  eFileFormat = EFileFormat
  modalMess: string = ''
  avatarDefault = require('@/assets/images/avatar-default.png')
  private page: number = 1
  isLastPage: boolean = false
  private limit: number = this.$store.state.setting.setting.setting_display
    .number_item_lists
  displayThumbnail: boolean =
    this.$store.state.setting.setting.setting_display.display_image_video ===
    EhumbNailsDisplay.DISPLAY_THUMBNAILS
  sortSelected: any = {}
  sortOptions: IDropDown[] = []
  canOpenFullImageModal: boolean = false
  fullOverviewSrc: string = ''


  @Watch('idGroupChat')
  watchRouteChange() {
    this.getGalleryByGroup()
  }

  created() {
    this.initSortDropdown()
    this.getGalleryByGroup()
  }

  @Watch('sortSelected')
  async onSortChange() {
    this.page = 1
    this.galleries = []
    await this.getGalleryByGroup()
  }

  get isAllMessageDeleted() {
    return this.galleries.every(
      (item: any) =>
        !(item.is_html_content === 0 && item.is_deleted_by_author !== 1)
    )
  }

  async getGalleryByGroup(loadMore?: boolean) {
    const { order_by, sorted_by } = this.sortSelected.value

    this.isLoading = true

    await GroupChatService.getGalleryByGroup(
        this.idGroupChat,
        this.page,
        this.limit,
        order_by,
        sorted_by
    )
      .then(res => {
        if (res.status === 200) {
          if (loadMore) {
            this.galleries = [...this.galleries, ...res.data.data]
          } else {
            this.galleries = res.data.data
          }
          this.isLastPage = this.page >= res.data.last_page

          if (!this.isLastPage && this.isAllMessageDeleted) {
            this.page += 1
            this.getGalleryByGroup(true)
          }
        }
      })
      .catch(err => {
        console.log(err)
      })

    setTimeout(() => {
      this.isLoading = false
    }, 300)
  }

  loadMore() {
    ++this.page
    this.getGalleryByGroup(true)
  }

  openFullImage(src: string) {
    this.fullOverviewSrc = src
    this.canOpenFullImageModal = true
  }

  formatDate(date: string) {
    return FormatDate.formatCompact(date)
  }

  getSenderAvatar(gallery: any): string {
    return gallery &&
      gallery.sender &&
      gallery.sender.user_profile &&
      gallery.sender.user_profile.avatar
      ? gallery.sender.user_profile.avatar
      : ''
  }

  getFileFormat(extension: string) {
    return CheckFileFormat.getFileFormat(extension)
  }

  /**
   * Open delete confirm modal
   */
  openModalConfirmDelete(gallery: any) {
    this.modalMess = this.$t('common.message.delete') as string
    this.$bvModal.show(`modal-confirm-chat-gallery-${gallery.id}`)
  }

  /**
   * Handle unknown array
   */
  hanldeUnknownArray(anyArray: any[]): any[] {
    return anyArray
  }

  /**
   * Delete gallery
   */
  deleteGallery(gallerySelected: any) {
    let msgIdHasGalleryDelete = gallerySelected.id
    let groupChatId = gallerySelected.group_chat_id

    GroupChatService.deleteGalleryByGroup(groupChatId, msgIdHasGalleryDelete)
      .then(res => {
        if (res.status === 200) {
          this.deleteMessage(
            msgIdHasGalleryDelete,
            gallerySelected.no_in_group_chat
          )
        }
      })
      .catch(err => {
        this.modalMess = this.$t('common.message.delete_fail_attach_file', {
          from: `No.${gallerySelected.no_in_group_chat}`
        }) as string

        this.$bvModal.show('modal-error-chat-gallery')
      })
  }

  async deleteMessage(deleteMessageId: number, index: number) {
    if (!deleteMessageId) {
      return
    }
    let dataDelete = {
      react_type: 2
    }
    this.$blockui.show()

    try {
      await MessageService.reactMessage(deleteMessageId, dataDelete)
      this.galleries = this.galleries.filter(
        (item: any) => item.id !== deleteMessageId
      )
      this.modalMess = this.$t('common.message.deleted_attach_file', {
        from: `No.${index}`
      }) as string
      this.$bvModal.show('modal-success-chat-gallery')

      if (!this.isLastPage && this.isAllMessageDeleted) {
        this.page += 1
        this.getGalleryByGroup(true)
      }
    } catch (err) {
      console.log(err)
    } finally {
      this.$blockui.hide()
    }
  }

  downloadFile(file: any) {
    this.file_name_download = file.file_name
    let fileIds = {
      file_ids: [file.id]
    }

    //handle dowload IOS not safari
    if (
      CheckDevice.iOSBrowerName().toLowerCase() !== CheckDevice.safari &&
      CheckDevice.isMobile() &&
      CheckDevice.getMobileOS() === CheckDevice.ios
    ) {
      window.open(file.path)
      return
    }

    this.$blockui.show()
    GroupChatService.downloadGallery(fileIds)
      .then(res => {
        if (res.status === 200) {
          this.hanldeDownloadFile(res)
        }
      })
      .catch(err => console.log(err))
      .finally(() => this.$blockui.hide())
  }

  hanldeDownloadFile(res: any) {
    const bytes = new Uint8Array(res.data)
    const blob = new Blob([bytes], { type: '*' })
    let a = document.createElement('a')
    const url = globalThis.URL.createObjectURL(blob)
    a.href = url
    a.setAttribute('download', this.file_name_download)
    a.click()
  }

  getFormatIconClass(extension: string) {
    return CheckFileFormat.getIconClassNameWithFileExtention(extension)
  }

  handleLongText(text: string, max?: number) {
    return PreviewText.covertToPreviewText(text, max)
  }

  getFileSize(file: any) {
    if (!file.size) return '0 B';
    const mb = file.size / 1024;

    if (mb >= 1) return mb.toFixed(2) + ' MB';
    console.log(typeof file.size)
    if (file.size >= 1) return file.size.toFixed(2) + ' KB';
    return file.size + ' B';
  }

  initSortDropdown() {
    const data = [
      {
        id: EListSort.UPDATE_DESC,
        value: {
          order_by: 'updated_at',
          sorted_by: 'desc'
        },
        text:
            this.$t('common.dropdown_sort.sort_date_time') +
            '' +
            this.$t('common.dropdown_sort.desc')
      },
      {
        id: EListSort.UPDATE_ASC,
        value: {
          order_by: 'updated_at',
          sorted_by: 'asc'
        },
        text:
            this.$t('common.dropdown_sort.sort_date_time') +
            '' +
            this.$t('common.dropdown_sort.asc')
      },
      {
        id: EListSort.SIZE_DESC,
        value: {
          order_by: 'size',
          sorted_by: 'desc'
        },
        text:
            this.$t('common.dropdown_sort.sort_by_size') +
            '' +
            this.$t('common.dropdown_sort.desc')
      },
      {
        id: EListSort.SIZE_ASC,
        value: {
          order_by: 'size',
          sorted_by: 'asc'
        },
        text:
            this.$t('common.dropdown_sort.sort_by_size') +
            '' +
            this.$t('common.dropdown_sort.asc')
      }
    ]
    this.sortOptions = data
    this.sortSelected = data[this.$store.state.setting.user_sort.group_chat_gallery]
  }
  handleSortChange(index: number) {
    this.sortSelected = this.sortOptions[index]
  }
}
